/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import FGBLabel from '../../components/Elements/FGBLabel/FGBLabel';
import UnderlineNavigation from '../../components/Elements/UnderlineNavigation/UnderlineNavigation';
import DateDisplay from '../../components/Events/EventList/SingleEventComponent/DateDisplay/DateDisplay';
import SinglePageLayout from '../../components/Layout/SinglePageLayout/SinglePageLayout';
/* COMPONENTS */
import HeaderSection from '../../components/Resources/HeaderSection/HeaderSection';
import Tile from '../../components/Resources/Tile/Tile';
import {
    SnowplowPageViewTracker,
    PAGE_VIEW_SECTIONS,
    PAGE_VIEW_TYPES,
} from '../../components/Analytics/Snowplow/SnowplowPageViewTracker';
/* CONSTANTS */
import { PREGNANCY_SECTION_KEYS, PREGNANCY_SECTION_MAP } from './constants';
import { PAGE_PROPS } from '../defaultProps';

/* STYLESHEETS */
import './PregnancyWeekByWeek.scss';

export default class PregnancyWeekByWeek extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            selectedMenuItem: 'FIRST_TRIMESTER',
        };
    }

    componentDidMount() {
        this.setHashInState();
        window.addEventListener('hashchange', this.setHashInState);
    }

    componentWillUnmount() {
        window.removeEventListener('hashChange', this.setHashInState);
    }

    setHashInState = () => {
        const hash = window.location.hash
            ? window.location.hash.slice(1)
            : 'firstTrimester';
        const selectedMenuItem = PREGNANCY_SECTION_MAP[hash].key;

        if (hash) {
            this.setState({ selectedMenuItem }, this.scrollToSection(hash));
        }
    };

    scrollToSection = (hash) => () => {
        if (!window.location.hash) return;

        // this scrolls to the element with an offset of 120px
        // to account for the navbar
        // the additional positioning is to account for scrolling
        // to element at different part of the page
        const element = document.querySelector(`a[name=${hash}]`);
        const headerOffset = 120;
        const bodyRect = document.body.getBoundingClientRect().top;
        const elementRect = element.getBoundingClientRect().top;
        const elementPosition = elementRect - bodyRect;
        const offsetPosition = elementPosition - headerOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
        });
    };

    renderPregnancyWeekByWeek = (key, index) => {
        const { image, title, hash } = PREGNANCY_SECTION_MAP[key];

        return (
            <React.Fragment key={`section-${index}`}>
                <a name={hash}>&nbsp;</a>
                <section className={`pregnancy-section ${hash}`}>
                    <div className={`header ${hash}`}>
                        <img src={image} alt="Pregnancy Trimester" />
                        <FGBLabel>{title}</FGBLabel>
                    </div>

                    <ul>{this.props[key].map(this.renderPregnancyTile)}</ul>
                </section>
            </React.Fragment>
        );
    };

    renderPregnancyTile = ({ title, weekNumber, contentUrl }) => {
        const modifiedTitle = title.split(':')[1];

        return (
            <li className="tile-item" key={weekNumber}>
                <a href={contentUrl}>
                    <Tile
                        title={modifiedTitle}
                        icon={<DateDisplay month="Week" day={weekNumber} />}
                    />
                </a>
            </li>
        );
    };

    handleMenuClick = (selectedMenuItem) => () =>
        this.setState({ selectedMenuItem });

    buildMenuItems = () => {
        return [
            {
                text: 'Conception & First Trimester',
                active:
                    this.state.selectedMenuItem ===
                    PREGNANCY_SECTION_MAP.firstTrimester.key,
                handleClickFunc: this.handleMenuClick(
                    PREGNANCY_SECTION_MAP.firstTrimester.key
                ),
                url: '#firstTrimester',
            },
            {
                text: 'Second Trimester',
                active:
                    this.state.selectedMenuItem ===
                    PREGNANCY_SECTION_MAP.secondTrimester.key,
                handleClickFunc: this.handleMenuClick(
                    PREGNANCY_SECTION_MAP.secondTrimester.key
                ),
                url: '#secondTrimester',
            },
            {
                text: 'Third Trimester',
                active:
                    this.state.selectedMenuItem ===
                    PREGNANCY_SECTION_MAP.thirdTrimester.key,
                handleClickFunc: this.handleMenuClick(
                    PREGNANCY_SECTION_MAP.thirdTrimester.key
                ),
                url: '#thirdTrimester',
            },
            {
                text: 'Maternity Leave',
                active:
                    this.state.selectedMenuItem ===
                    PREGNANCY_SECTION_MAP.maternityLeave.key,
                handleClickFunc: this.handleMenuClick(
                    PREGNANCY_SECTION_MAP.maternityLeave.key
                ),
                url: '#maternityLeave',
            },
            {
                text: 'Back to Work',
                active:
                    this.state.selectedMenuItem ===
                    PREGNANCY_SECTION_MAP.backToWork.key,
                handleClickFunc: this.handleMenuClick(
                    PREGNANCY_SECTION_MAP.backToWork.key
                ),
                url: '#backToWork',
            },
        ];
    };

    render() {
        const menuItems = this.buildMenuItems();

        return (
            <div className="page-PregnancyWeekByWeek">
                <SnowplowPageViewTracker
                    pageType={PAGE_VIEW_TYPES.COLLECTION}
                    pageSection={PAGE_VIEW_SECTIONS.ADVICE}
                />
                <SinglePageLayout
                    PAGE_PROPS={this.props.PAGE_PROPS}
                    hasBottomBanner={false}
                >
                    <HeaderSection
                        title="Pregnancy Week by Week"
                        description="A resource to help you manage your job and life, through and after your pregnancy."
                    />

                    <UnderlineNavigation menuItems={menuItems} />

                    {PREGNANCY_SECTION_KEYS.map(this.renderPregnancyWeekByWeek)}
                </SinglePageLayout>
            </div>
        );
    }
}

PregnancyWeekByWeek.propTypes = {
    PAGE_PROPS: PAGE_PROPS.isRequired,
};
